// @flow
import React from "react";
import type { FlagContentProps } from "../types";

const Finland = ({ circular }: FlagContentProps) =>
  circular ? (
    <React.Fragment>
      <g clipPath="url(#clip0_3_4)">
        <path d="M25.9769 0H-6V20H25.9769V0Z" fill="#F8F8F9" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26 7.8355H8.74262V0H4.05912V7.8355H-6V12.1645H4.05912V20H8.74262V12.1645H26V7.8355Z"
          fill="#2959A3"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_4">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <path d="M31.9769 0H0V20H31.9769V0Z" fill="#F8F8F9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 7.8355H14.7426V0H10.0591V7.8355H0V12.1645H10.0591V20H14.7426V12.1645H32V7.8355Z"
        fill="#2959A3"
      />
    </React.Fragment>
  );

// $FlowFixMe
export default React.memo(Finland);
